import { axiosBaseQuery, request } from 'react-common'
import { createApi } from '@reduxjs/toolkit/query/react'
import type { ActivityWorkflowId, ObjectiveWorkflowId } from '@/api/models/aggregate'
import type { ProctoringSessionModel, StartProctoringRequestModel } from '@/api/models/proctoringSession'

export const proctoringSessionApi = createApi({
  reducerPath: 'proctoringSessionApi',
  baseQuery: axiosBaseQuery(request),
  endpoints: (builder) => ({
    getActivityProctoringSession: builder.query<
      ProctoringSessionModel,
      { objectiveWorkflowId: ObjectiveWorkflowId; activityWorkflowId: ActivityWorkflowId }
    >({
      query: ({ objectiveWorkflowId, activityWorkflowId }) => ({
        url: `users/me/objective-workflows/${objectiveWorkflowId}/activity-workflows/${activityWorkflowId}/last-proctoring-session`,
        method: 'get',
      }),
    }),
    getProctoringStartToken: builder.query<
      StartProctoringRequestModel,
      {
        objectiveWorkflowId: ObjectiveWorkflowId
        activityWorkflowId: ActivityWorkflowId
        activityPathId?: string
      }
    >({
      query: ({ objectiveWorkflowId, activityWorkflowId, activityPathId }) => ({
        url: `users/me/objective-workflows/${objectiveWorkflowId}/activity-workflows/${activityWorkflowId}/last-proctoring-session/start-token`,
        method: 'get',
        params: activityPathId ? { query: { activityPathId } } : undefined,
      }),
    }),
  }),
})

export const {
  useGetActivityProctoringSessionQuery,
  useLazyGetActivityProctoringSessionQuery,
  useGetProctoringStartTokenQuery,
  useLazyGetProctoringStartTokenQuery,
} = proctoringSessionApi
